import { transformToPixels, isMobile } from "../common/helpers";

export const useFooter = () => {
    const expansions = document.querySelectorAll(
        ".js-ns-footer-navigation-block-expansion"
    );
    const contents = document.querySelectorAll(
        ".js-ns-footer-navigation-block-content"
    );

    const handleInert = () => {
        const windowWidth = window.innerWidth;

        if (windowWidth > 768) {
            contents.forEach(($el) => $el.removeAttribute("inert"));

            return;
        }

        expansions.forEach(($el) => {
            const $content = $el.nextElementSibling;

            if ($el.classList.contains("active") === true) {
                $content.removeAttribute("inert");

                return;
            }

            $content.setAttribute("inert", "true");
        });
    };

    const handleListExpansion = () => {
        expansions.forEach(($el) => {
            let isOpened = false;

            $el.addEventListener("click", () => {
                const $content = $el.nextElementSibling;
                const $list = $content.firstElementChild;
                const height = $list.clientHeight;

                $el.classList.toggle("active");

                if (isOpened === false) {
                    $el.setAttribute("aria-expanded", "true");

                    $content.style.height = transformToPixels(height);
                    $content.removeAttribute("inert");
                } else {
                    $el.setAttribute("aria-expanded", "false");

                    $content.style.height = 0;
                    $content.setAttribute("inert", "true");
                }

                isOpened = !isOpened;
            });
        });
    };

    const init = () => {
        handleListExpansion();
        handleInert();
    };

    const initFooter = () => {
        document.addEventListener("DOMContentLoaded", init);
        window.addEventListener("resize", handleInert);
    };

    return {
        initFooter,
    };
};
